import { LocalizedField } from '@/models/localization.model';
import { PropertyType } from '@/models/property.model';
import { DocumentSourceEnum } from './documents.model';

export enum DocumentsSettingsEndpoints {
  ROOT = '/settings',
  PROPERTY_TYPE = '/property-types',
  REQUIRED_DOCUMENTS = '/required-documents',
}

export const getDocumentsSettingsEndpoints = ({ id, propertyType }: { id?: string; propertyType: PropertyType }) => ({
  CREATE_REQUIRED_DOCUMENTS: `${DocumentsSettingsEndpoints.ROOT}${DocumentsSettingsEndpoints.PROPERTY_TYPE}/${propertyType}${DocumentsSettingsEndpoints.REQUIRED_DOCUMENTS}`,
  GET_REQUIRED_DOCUMENTS: `${DocumentsSettingsEndpoints.ROOT}${DocumentsSettingsEndpoints.PROPERTY_TYPE}/${propertyType}${DocumentsSettingsEndpoints.REQUIRED_DOCUMENTS}`,
  UPDATE_REQUIRED_DOCUMENTS: `${DocumentsSettingsEndpoints.ROOT}${DocumentsSettingsEndpoints.PROPERTY_TYPE}/${propertyType}${DocumentsSettingsEndpoints.REQUIRED_DOCUMENTS}/${id}`,
  DELETE_REQUIRED_DOCUMENTS: `${DocumentsSettingsEndpoints.ROOT}${DocumentsSettingsEndpoints.PROPERTY_TYPE}/${propertyType}${DocumentsSettingsEndpoints.REQUIRED_DOCUMENTS}/${id}`,
});

export interface IDocument extends LocalizedField<'name'>, LocalizedField<'description'> {
  id?: string;
  createId?: string;
  is_required: boolean;
  property_type: PropertyType;
  source_type: DocumentSourceEnum;
}

// ----------------- DTOs ----------------

export interface IGetDocumentsDTO {
  property_type: PropertyType;
}

export type TUpdateDocumentDTO = Omit<IDocument, 'source_type'>;

export type TCreateDocumentDTO = Omit<IDocument & { createId?: string }, 'id'>;

export interface IDeleteDocumentDTO {
  id: string;
  property_type: PropertyType;
}

// ------------ Responses --------------

export type TGetDocumentsListResponse = Record<DocumentSourceEnum, IDocument[]>;

export type TGeneralDocumentResponse = IDocument;
